export const CorporateContractType = {
    ALPHA: "آلفا",
    PRO: "پرو",
    NEO: "نئو",
    GOLD: "طلایی",
    PERSONAL: "شخصی",
    NON_WITHDRAWABLE: "خرید",
}
